(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.mobileSearchInit) return;
    window.mobileSearchInit = true;

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mobile-search-toggle]');
      if (!toggle) return;
      e.preventDefault();

      var panel = document.querySelector('[data-mobile-inline-search]');
      if (!panel) return;

      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        var input = panel.querySelector('input[type="search"]');
        if (input) {
          input.setAttribute('autocomplete', 'off');
          input.setAttribute('autocorrect', 'off');
          input.setAttribute('autocapitalize', 'off');
          input.setAttribute('spellcheck', 'false');
          input.focus();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
